<template>
    <div v-if="visible">
      <v-checkbox
       
        hide-details
        class="caption mx-3 mb-1"
        v-model="disponibleCheck"
      >
        <template v-slot:label>
          <div>Disponible</div>
        </template>
      </v-checkbox>
    </div>
  </template>
  
  <script>
  import { mapState, mapMutations, mapGetters } from "vuex";
  export default {
      name: "FiltroDisponible",
    methods: {
      ...mapMutations(["SET_DISPONIBLE"]),
    },
    computed: {
      ...mapGetters(["filterconsolidado"]),
      ...mapState(["filter", "dataUser"]),
      isDisponible() {
        return this.filterconsolidado.some((x) => x.Disponible !== 0);
      },
      visible() {
        return this.dataUser.IndAutenticado && this.isDisponible && this.dataUser.TipoUsuario == 'U'
      },
      disponibleCheck: {
        get() {
          return this.filter.disponible;
        },
        set() {
          this.SET_DISPONIBLE();
        },
      },
    },
  };
</script>